var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"not-found text-center"},[_c('h3',{staticClass:"text-h3 mb-5"},[_vm._v("Esta Pagina no existe!")]),_c('router-link',{staticClass:"blue--text text-h6",attrs:{"to":_vm.redirect}},[_vm._v("Volver a casa")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }